import { Flex } from "antd";

import Notifications from "./components/Notifications";
import Attendance from "./components/Attendance";
import News from "./components/News";

const Dashboard = () => {
  return (
    <Flex vertical className="p-6">
      <News />
      <Notifications />
      <Attendance />
    </Flex>
  );
};

export default Dashboard;
